import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth, applyTheme } from '../../contexts/AuthContext';
import { useApi } from '../../hooks/useApi';
import { useToast } from '../Shared/Toast';
import { useTranslation } from '../../contexts/LanguageContext';
import Sidebar from './Sidebar';
import { LoadingOverlay } from '../Shared/Spinner';

/**
 * AppShell — laedt Profil bei Mount falls noch nicht vorhanden, rendert Sidebar + Outlet.
 */
export default function AppShell() {
  const { token, profile, setProfile, profileLoading, setProfileLoading, logout } = useAuth();
  const { api } = useApi();
  const { showToast } = useToast();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || profile || profileLoading) return;
    setProfileLoading(true);
    api('auth/profile')
      .then((data) => {
        setProfile(data);
        if (data?.profile?.theme) applyTheme(data.profile.theme);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          navigate('/login', { replace: true });
        } else {
          showToast(t('common.error') + ': ' + (err?.message || ''), 'error');
          logout();
          navigate('/login', { replace: true });
        }
      })
      .finally(() => setProfileLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!profile) {
    return <LoadingOverlay />;
  }

  return (
    <div className="screen-app">
      <Sidebar />
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
